import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Avatar,
} from "@mui/material";
import Navbar from "./Navbar";
import {Footer} from "../../shared";
import { Header } from "../../shared";

const API_URL = process.env.REACT_APP_API_URL + "/userInfo";
// const API_URL = "http://localhost:6002/userInfo"; // Your backend API endpoint

const UserAccount = () => {
  const [user, setUser] = useState(null); // Store user data
  const [loading, setLoading] = useState(false); // Manage loading state
  const [error, setError] = useState(null); // Manage error state

  // Fetch user data from the API
  useEffect(() => {
    const userFromCookie = Cookies.get("userId"); // Get userId from cookies
    console.log("User ID from cookie:", userFromCookie); // Debug log

    if (userFromCookie) {
      fetchUser(userFromCookie); // Fetch user data
    } else {
      setError("No user ID found in cookies.");
    }
  }, []);

  // Fetch user data from API
  const fetchUser = async (userId) => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}?userId=${userId}`);

      if (response.data.success) {
        setUser(response.data.data); // Set the user data from the response
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError("Failed to fetch user data");
      toast.error("Error fetching user data");
      console.error("Error fetching user data:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "white",
      }}
    >
      {/* Navbar */}
      <Header />

      {/* Main Content */}
      <Box component="main" sx={{ flex: 1, py: 6 }}>
        <Container maxWidth="md">
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Typography
              variant="h3"
              gutterBottom
              sx={{ fontWeight: 700, color: "#333", mb: 4 }}
            >
              User Account
            </Typography>

            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "300px",
                }}
              >
                <CircularProgress
                  size={60}
                  thickness={4}
                  sx={{ color: "#1976d2" }}
                />
              </Box>
            ) : error ? (
              <Typography
                variant="h6"
                color="error"
                sx={{ textAlign: "center", mb: 4 }}
              >
                {error}
              </Typography>
            ) : (
              user && (
                <Card
                  sx={{
                    width: "100%",
                    maxWidth: "600px",
                    borderRadius: 3,
                    boxShadow: 6,
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#1976d2",
                      p: 3,
                      textAlign: "center",
                    }}
                  >
                    <Avatar
                      alt={user.name}
                      src={user.picture}
                      sx={{
                        width: 100,
                        height: 100,
                        margin: "0 auto",
                        border: "4px solid white",
                      }}
                    />
                    <Typography
                      variant="h5"
                      sx={{ mt: 2, color: "white", fontWeight: 600 }}
                    >
                      {user.name}
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#e0e0e0" }}>
                      {user.email}
                    </Typography>
                  </Box>
                  <CardContent sx={{ p: 4 }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: 600, color: "#555" }}
                        >
                          Phone Number
                        </Typography>
                        <Typography variant="body1" sx={{ color: "#333" }}>
                          {user.phoneNumber || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: 600, color: "#555" }}
                        >
                          City
                        </Typography>
                        <Typography variant="body1" sx={{ color: "#333" }}>
                          {user.city || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: 600, color: "#555" }}
                        >
                          State
                        </Typography>
                        <Typography variant="body1" sx={{ color: "#333" }}>
                          {user.state || "N/A"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              )
            )}
          </Box>
        </Container>
      </Box>

      {/* Footer */}
      <Box component="footer" sx={{ mt: "auto" }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default UserAccount;
